<template>
  <div class="Home_main">
    <div class="mainBox">
      <div class="left-item">
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="var(--primary-color2)"
          text-color="#7F8488"
          active-text-color="#44D7B6"
          router
        >
        
        <el-menu-item index="/system/siteManagement" v-if="$store.state.role ==1">
            <i class="el-icon-setting"></i>
            <span slot="title">站点管理</span>
          </el-menu-item>
        <el-menu-item index="/system/userManagement" v-if="$store.state.role ==1">
            <i class="el-icon-setting"></i>
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-menu-item index="/system/passwdSet">
            <i class="el-icon-setting"></i>
            <span slot="title">修改密码</span>
          </el-menu-item>

          <el-menu-item index="/system/operationSet">
            <i class="el-icon-s-order"></i>
            <span slot="title">操作日志</span>
          </el-menu-item>
        </el-menu>
      </div>

      <div class="right-item">
        <router-view />
        <!-- <baiduMap
          id="map"
          ref="homemap"
          style="height: 120%; width: 100%"
          :dataList="$store.state.locationList"
          :CoordMap="$store.state.CoordMap"
        ></baiduMap> -->
      </div>
    </div>

    <!-- <div class="backgroundMap">
        <baiduMap
          id="map"
          ref="homemap"
          style="height: 50%; width: 50%"
          :dataList="$store.state.locationList"
          :CoordMap="$store.state.CoordMap"
        ></baiduMap>
      </div> -->
  </div>
</template>
  
  <script>
import containerHeader from "@/components/container_header.vue";
import baiduMap from "@/components/baiduMap.vue";
import axios from "axios";
export default {
  components: {
    baiduMap,
    containerHeader,
  },
  data() {
    return {
      options: [],
      value: "",
      filteredData: [],
    };
  },

  mounted() {},

  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
  computed: {},
};
</script>
  
  <style lang="less" scoped>
.Home_main {
  font-size: 24px;
  min-width: 1440px;
  z-index: 15;
  overflow: auto;
  box-sizing: border-box;
  height: 100%;
  .menu_title {
    width: 100%;
    height: 1.625rem;
    font-size: 1rem;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #6d7278;
    line-height: 1.5rem;
    padding-top: 1rem;
    display: block;
    padding-left: 1.625rem;
  }
  .el-menu {
    height: 100%;
  }
  .el-menu-item {
    font-size: 0.875rem;
    height: 4rem;
    width: 10rem;
    line-height: 4rem;
  }
}

.backgroundMap {
  // background: url("../assets/background.jpg") no-repeat;
  // padding-left: 200px;
  width: 50%;
  // height: 100%;
  height: calc(100% - 79px);
  position: absolute;
  top: 79px;
  left: 20px;
  opacity: 1;
  z-index: 2;
  // background-size: cover;
  // background-position: center;
}

.mainBox {
  height: 100%;
  overflow: hidden;
  display: flex;
  columns: row;
}

.left-item {
  z-index: 4;
  height: 100%;
  width: 10rem;
}

.right-item {
  flex: 1;
  z-index: 4;
  height: 100%;
  min-height: 636px;
  overflow: hidden;
  padding: 1.25rem;
  box-sizing: border-box;
  /deep/ .el-divider--vertical {
    height: 2.6875rem !important;
    background-color: #244447;
  }
}

@media screen and (max-width: 1440px) {
  .Home_main {
    font-size: 24px;
    min-width: 1440px;
    z-index: 15;
    overflow: auto;
    box-sizing: border-box;
    height: 100%;
    .menu_title {
      width: 100%;
      height: 26px;
      font-size: 16px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #6d7278;
      line-height: 24px;
      padding-top: 16px;
      padding-left: 26px;
      display: block;
    }
    .el-menu-item {
      font-size: 14px;
      height: 56px;
      line-height: 56px;
      width: 160px;
    }
  }

  .left-item {
    z-index: 4;
    width: 160px;
    height: 100%;
  }

  .right-item {
    flex: 1;
    z-index: 4;
    height: 100%;
    min-height: 636px;
    overflow: hidden;
    padding: 20px;
    box-sizing: border-box;
    /deep/ .el-divider--vertical {
      height: 43px !important;
      background-color: #244447;
    }
  }
}
</style>
  
    


// WEBPACK FOOTER //
// src/pages/systemSet/index.vue